import { SignUp, useAuth } from "@clerk/clerk-react";
import { Navigate } from "@tanstack/react-router";
import { clerkAppearance } from "../clerkAppearance";
import { AuthShell } from "./AuthShell";

/** Public, full-screen sign-up. Clerk handles the flow; we style it to Cendre. */
export function SignUpPage() {
  const { isLoaded, isSignedIn } = useAuth();
  if (isLoaded && isSignedIn) return <Navigate to="/chat" />;

  return (
    <AuthShell>
      <SignUp
        routing="hash"
        signInUrl="/sign-in"
        fallbackRedirectUrl="/chat"
        appearance={clerkAppearance}
      />
    </AuthShell>
  );
}
